import React, { useState } from "react";
import DefaultButton from "../../styles/materialButtonStyle";
import { DelayInput } from "react-delay-input/lib/Component";
import Dropdown from "rc-dropdown";
import { useTranslation } from "react-i18next";
import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup, StyledFilterWrapper, StyledShowFilterBtn
} from "../../elements/filter/styledFiter";


const ServiceFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslation("servicePage");

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "service.name": ""
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
        <StyledFilterDropdownWrapper>
          <StyledFilterBlock actions>
            <StyledFilterGroup className="clear-btn">
              <DefaultButton
                color="transparent"
                onClick={handleClearFilter}
              >
                {t("filter.clearBtn")}
              </DefaultButton>
            </StyledFilterGroup>
            <StyledFilterGroup className="close-btn">
              <StyledFilterCloseBtn onClick={() => setVisible(false)} />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.filterBy")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="1">
            <StyledFilterGroup>
              <label htmlFor="name">
                {t("filter.name")}
              </label>
              <DelayInput
                id="name"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "service.name": event.target.value, page: 1 })}
                name="name"
                value={filterData["service.name"]}
                type="text"
              />
            </StyledFilterGroup>
          </StyledFilterBlock>
        </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper
      pt="20"
      pb="40"
      id="filter"
    >
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default ServiceFilter;